import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { getAxiosErrorMessage, is } from '../../../utils';
import { PopupAlertType } from '../../../constants';
import { usePopupAlertsReducer } from './popupAlertsReducer';
import { ServerErrorBaseModel } from '../../../models';

export function useNetworkErrorHandler(error: AxiosError): void {
  const { showAlert } = usePopupAlertsReducer();

  useEffect(() => {
    if (!error) return;

    let errMsg = getAxiosErrorMessage(
      error as AxiosError<ServerErrorBaseModel>,
    );
    errMsg = is.string(errMsg) ? errMsg : JSON.stringify(errMsg);

    showAlert({
      variant: PopupAlertType.Error,
      content: errMsg,
    });
  }, [error]);
}
